import { createGlobalStyle } from 'styled-components';

const fonts = `
  /* ibm-plex-mono-regular - latin */
  @font-face {
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 400;
    src: url('./assets/fonts/ibm-plex-mono-v12-latin-regular.eot'); /* IE9 Compat Modes */
    src: local(''),
      url('./assets/fonts/ibm-plex-mono-v12-latin-regular.eot?#iefix')
        format('embedded-opentype'),
      /* IE6-IE8 */ url('./assets/fonts/ibm-plex-mono-v12-latin-regular.woff2')
        format('woff2'),
      /* Super Modern Browsers */
        url('./assets/fonts/ibm-plex-mono-v12-latin-regular.woff')
        format('woff'),
      /* Modern Browsers */
        url('./assets/fonts/ibm-plex-mono-v12-latin-regular.ttf')
        format('truetype'),
      /* Safari, Android, iOS */
        url('./assets/fonts/ibm-plex-mono-v12-latin-regular.svg#IBMPlexMono')
        format('svg'); /* Legacy iOS */
  }

  /* ibm-plex-mono-700 - latin */
  @font-face {
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 700;
    src: url('./assets/fonts/ibm-plex-mono-v12-latin-700.eot'); /* IE9 Compat Modes */
    src: local(''),
      url('./assets/fonts/ibm-plex-mono-v12-latin-700.eot?#iefix')
        format('embedded-opentype'),
      /* IE6-IE8 */ url('./assets/fonts/ibm-plex-mono-v12-latin-700.woff2')
        format('woff2'),
      /* Super Modern Browsers */
        url('./assets/fonts/ibm-plex-mono-v12-latin-700.woff') format('woff'),
      /* Modern Browsers */
        url('./assets/fonts/ibm-plex-mono-v12-latin-700.ttf') format('truetype'),
      /* Safari, Android, iOS */
        url('./assets/fonts/ibm-plex-mono-v12-latin-700.svg#IBMPlexMono')
        format('svg'); /* Legacy iOS */
  }
`;

const global = `
  html {
    box-sizing: border-box;
    color-scheme: dark;
    theme: dark;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  img {
    max-height: 100%;
  }

  button,
  input,
  select,
  textarea {
    font-family: inherit;
    font-size: 100%;
  }

  body {
    font-family: 'IBM Plex Mono', serif;
    color: #fff;
    background: #545e75;
  }

  html,
  body,
  #root {
    height: 100%;
  }
`;

const reset = `
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure, 
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
`;

const GlobalStyle = createGlobalStyle`
  ${fonts}
  ${reset}
  ${global}
`;

export default GlobalStyle;
